var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9095 22.1301C26.5851 22.5133 26.5851 23.4867 25.9095 23.8699L12.1109 31.6948C11.4443 32.0729 10.6176 31.5913 10.6176 30.825L10.6176 15.175C10.6176 14.4087 11.4443 13.9271 12.1109 14.3052L25.9095 22.1301Z",
    stroke: "currentColor",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27.8235,
    y: 13.6,
    width: 4.17647,
    height: 17.9333,
    rx: 1,
    stroke: "currentColor",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayForward);
export default __webpack_public_path__ + "static/media/play-forward.8b0a04d97d17b41dc53bfffd61bcaece.svg";
export { ForwardRef as ReactComponent };